.card {
  width: 100%;
  height: 180px;
  box-sizing: border-box;
  border-radius: 16px;
  background: white;
  padding: var(--spacing-inset-size-sm);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL3BhZ2VzL0Rhc2hib2FyZC9mcmFnbWVudHMvQ29udGVudC9HcmlkL2ZyYWdtZW50cy9DYXJkRXZlbnQiLCJzb3VyY2VzIjpbIkNhcmRFdmVudC5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5jYXJkIHtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTgwcHg7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIGJvcmRlci1yYWRpdXM6IDE2cHg7XG4gIGJhY2tncm91bmQ6IHdoaXRlO1xuICBwYWRkaW5nOiB2YXIoLS1zcGFjaW5nLWluc2V0LXNpemUtc20pO1xufSJdfQ== */